import axiosInstance from "./axios.instance";

const API_CREATE_MEETING_INFO = async (data) => {
  try {
    const resp = await axiosInstance.post("/meetinginfo", data);
    return resp;
  } catch (err) {
    throw err;
  }
};

const API_GET_ALL_MEETING_INFO = async ({
  page = 0,
  limit = 30,
  status = "",
  global = "",
  startTimestamp = "",
  endTimestamp = "",
}) => {
  try {
    const params = {
      page,
      limit,
      status,
      global,
      startTimestamp,
      endTimestamp,
    };
    const resp = await axiosInstance.get("/meetinginfo", {
      params,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_GET_ONE_MEETING_INFO = async (id) => {
  try {
    const resp = await axiosInstance.get(`/meetinginfo/${id}`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_UPDATE_MEETING_INFO = async (id, data) => {
  try {
    const resp = await axiosInstance.put(`/meetinginfo/${id}`, data);
    return resp;
  } catch (err) {
    throw err;
  }
};

const API_DELETE_MEETING_INFO = async (id) => {
  try {
    const resp = await axiosInstance.delete(`/meetinginfo/${id}`);
    return resp;
  } catch (err) {
    throw err;
  }
};

const API_CANCEL_MEETING = async (id) => {
  try {
    const resp = await axiosInstance.post(`/meetinginfo/${id}/cancel`);
    return resp;
  } catch (err) {
    throw err;
  }
};
const API_SEND_REMINDER = async (id) => {
  try {
    const resp = await axiosInstance.post(`/meetinginfo/${id}/reminder`);
    return resp;
  } catch (err) {
    throw err;
  }
};

export {
  API_CREATE_MEETING_INFO,
  API_GET_ALL_MEETING_INFO,
  API_GET_ONE_MEETING_INFO,
  API_UPDATE_MEETING_INFO,
  API_DELETE_MEETING_INFO,
  API_SEND_REMINDER,
  API_CANCEL_MEETING,
};
